(() => {
  const sticky = document.querySelector('[data-patrona-mobile-add]');
  if (!sticky) return;
  const main = document.querySelector('main');
  const original = () => main?.querySelector('product-form button[name="add"]');
  const sync = () => {
    const button = original();
    sticky.hidden = !button;
    sticky.disabled = !button || button.disabled || button.classList.contains('loading');
    sticky.querySelector('span').textContent = button?.classList.contains('loading') ? 'Agregando…' : button?.disabled ? 'No disponible' : 'Agregar al carrito';
  };
  sticky.addEventListener('click', () => {
    const button = original();
    if (button && !button.disabled && !button.classList.contains('loading')) button.click();
  });
  if (main) new MutationObserver(sync).observe(main,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class']});
  sync();
})();
